import { isMobile } from '../../components/utils'
import { getCurrentTimestamp } from '../../helpers/helper'
import { stripTags } from '../../helpers/string'
import { makeRequest } from '../apiClient'
import { getFromCache, hashCode, putToCache } from '../cache'
import dateFormat from 'dateformat'
import { assetUrl } from '../../helpers/urlBuilder'

const HR_INSIDER_CACHE_TIME = process.env.HR_INSIDER_EXPIRATION_CACHE
	? parseInt(process.env.HR_INSIDER_EXPIRATION_CACHE)
	: 0
const HR_INSIDER_KEY = 'hrInsiderArticles'

export interface IArticle {
	title: string | null
	image: string | null
	description: string | null
	url: string | null
	category: string | null
	date: string | null
}

export default async function getArticleFromHRInsider(
	API_PATH: string,
	isImageSizeMobile?: boolean
) {
	const CACHE_VERSION = hashCode(API_PATH)

	let articles: IArticle[] = await getFromCache(HR_INSIDER_KEY, CACHE_VERSION)

	if (!!articles && articles.length == 0) {
		let data = []

		try {
			data = await makeRequest(`${API_PATH}`)

			articles = data.map((item: any) => {
				const image = item.cover_picture;
				const tags = item.tags || []
				const category = tags.map((item: any) => item.name).join(', ');

				return {
					title: stripTags(item.title),
					image: image,
					description: stripTags(item.short_description),
					url: item.hrDetailSlug,
					category: category,
					date: dateFormat(item?.date ?? '', 'dd/mm/yyyy')
				}
			});

			await putToCache(
				HR_INSIDER_KEY,
				articles,
				HR_INSIDER_CACHE_TIME,
				CACHE_VERSION
			)
		} catch (err) {
			// TODO Log Error To Sentry
			console.error(err)
			return articles
		}
	}

	return articles
}
